import { render, staticRenderFns } from "./seek_truth_weeklies.vue?vue&type=template&id=5f844fcd&"
import script from "./seek_truth_weeklies.vue?vue&type=script&lang=js&"
export * from "./seek_truth_weeklies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports